//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import SidebarHeader from '@/components/SidebarHeader'
import SearchResult from '@/components/SearchResult'
import { ApolloClient } from '@/vue-apollo'
import { gql } from '@apollo/client/core'

export default {
  name: 'Sidebar',

  components: {
    SidebarHeader,
    SearchResult
  },

  data() {
    return {
      records: []
    }
  },

  computed: {
    ...mapState({
      sidebarTags: state => state.sidebarTags,
      sidebarSearch: state => state.sidebarSearch
    })
  },

  watch: {
    sidebarTags() {
      this.searchService()
    },
    sidebarSearch() {
      this.searchService()
    }
  },

  methods: {
    statusColor(status) {
      if (!status) {
        return
      }

      if (status.toUpperCase() === 'ACTIVE') {
        return 'green'
      }
      if (status.toUpperCase() === 'CANCELLED') {
        return 'red'
      }
    },

    getServices(page = 1) {
      return ApolloClient.query({
        query: gql`
          query Query($search: String, $status: [String], $page: Int) {
            serviceSearch(
              search: $search
              status: $status
              page: $page
              orderBy: [{ column: SERVICE_I_D, order: DESC }]
            ) {
              data {
                id
                status
                subnet_size
                status_percentage
                status_colour
                delivery_method {
                  id
                  name
                }
                location {
                  id
                  premise {
                    id
                    address
                  }
                }
                product {
                  id
                  service_reference
                  product_reference
                }
                account {
                  id
                  name
                }
                plan {
                  id
                  speed
                }
              }

              paginatorInfo {
                currentPage
                lastPage
              }
            }
          }
        `,
        variables: {
          search: this.sidebarSearch || undefined,
          status: this.sidebarTags,
          page: page
        }
      })
    },

    loadMoreServices(index, done) {
      this.getServices(index).then(result => {
        const records = result?.data.serviceSearch?.data || []
        if (records.length) {
          this.records = this.records.concat(records)
          done()
        } else {
          done(true)
        }
      })
    },

    searchService() {
      this.records = []
      this.$refs.infinityScroll.reset()
      this.$refs.infinityScroll.resume()
      this.$refs.infinityScroll.trigger()
    }
  }
}
